<div class="offers-progress-dialog-logo"
     [ngClass]="{'offers-progress-dialog-logo--active': correctOffersAmount > 0}"
>
    <img [src]="logo.src"
         [style.max-width.px]="logo.sizeDefinition.maxWidth"
         alt="">
</div>
